<template>
  <div class="comment-section">
    <h2 class="block-title">{{$_('comment')}}</h2>
    <div class="form-block">
      <div class="display-flex column-xs row-md">
        <div class="form-field comment-text-field">
          <textarea class="comment-text" @input="vSetStore('tcom', $event.target.value)"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormComment',
  methods: {
    vSetStore(key, value) {
      this.$store.dispatch('echantillon/SET_HEADER', {key, value});
    }
  }
};
</script>

<style scoped>
.comment-section {
  border: solid 1px #e1e1e1;
  padding: 10px 25px;
  border-radius: 8px;
}
.comment-text-field {
  width: 100%;
}
@media screen and (max-width: 800px){
  .comment-section {
    padding: 0px 20px
  }
}
</style>